export class SecurityConstants {
  //IdentityConstants
  public static readonly USER_ROLE: string = 'User';
  public static readonly ADMINISTRATOR_ROLE: string = 'Administrator';
  public static readonly CLIENT_ROLE: string = 'Client';
  public static readonly ROLE_CLAIM: string = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
  public static readonly USERNAME_CLAIM: string = 'http://camille.org/claims/username';
  public static readonly SUBJECT_OBLIGED_ID: string = 'SubjectObligedId';

  //IdentityErrors
  public static readonly DUPLICATE_USER_NAME: string = 'DuplicateUserName';
  public static readonly INVALID_TOKEN: string = 'InvalidToken';

  //Local Storage Constants
  public static readonly USER_ID: string = 'Id';
  public static readonly TOKEN_KEY: string = 'ALDDA-VEH-Access-Token';
  public static readonly LOGIN_KEY: string = 'loginDate';
  public static readonly USER_ROLES_KEY: string = 'zorbekTemplateProjectUse';
  public static readonly REMEMBER_ME_KEY: string = 'rememberMeToken';
  public static readonly PERMISSIONS_KEY: string = 'JS_45@%s-45';

  public static readonly SHOW_CURRENT_SYSTEM_ALERT: string = 'showCurrentSystemAlert';
  public static readonly SHOW_CONFIRMED_EMAIL_ALERT: string = 'showConfirmedEmailAlert';
}
